import { ApexChart } from './ApexChart';

export default ApexChart;
